import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Form,
    Tooltip,
    Input,
    Popconfirm,
} from "antd";
import {
    UnorderedListOutlined,
    EditFilled,
    DeleteFilled,
} from "@ant-design/icons";
import { convertColumns } from "../../../../utils/columnconverter";
import { notify } from "../../../../redux/actions";
import { connect } from "react-redux";
import aictia from "../../../../const/api";
import { useTranslation } from "react-i18next";
import { whiteSpace } from "../../../../utils/rules";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
const TypeOfActiviyAictia = (props) => {
    const mainUrl = 'TypeOfActivity'
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [positions, setPositions] = useState([]);
    const [spin, setSpin] = useState(false);
    const [editing, setEditing] = useState(null);
    const [lang, setLang] = useState([]);

    const cols = [
        { key: "index", value: "#", con: true },
        { key: "name", value: t("name"), con: true },
        { key: "id", value: "", con: false },
    ];
    const nameInput = useRef();

    // props
    const { notify } = props;

    const columns = [
        {
            title: "#",
            key: "1",
            dataIndex: "index",
            width: 80,
        },
        {
            title: t("name"),
            key: "2",
            dataIndex: "name",
        },
        {
            title: "Əməliyyatlar",
            key: "3",
            dataIndex: "id",
            width: 30,
            render: (i) => {
                return (
                    <div className="flex flex-end">
                        <Popconfirm
                            placement="topRight"
                            title={t("areYouSure")}
                            onConfirm={() => deletePosition(i)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <Tooltip className="ml-5" title={t("delete")}>
                                <Button className="border-none" type="text" shape="circle">
                                    <DeleteFilled />
                                </Button>
                            </Tooltip>
                        </Popconfirm>
                        <Tooltip className="ml-5" title={t("edit")} placement="topRight">
                            <Button
                                className="border-none"
                                type="text"
                                shape="circle"
                                onClick={() => setEditingObject(i)}
                            >
                                <EditFilled />
                            </Button>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];

    const setEditingObject = async (i) => {
        setEditing(i);
        await aictia.get(mainUrl + `/${i}`).then((res) => {
            let obj = {};
            res.data.typeOfActivity_Languages.map((item) => {

                obj[`name_${item.languageId}`] = item.name;

            }
            );
            form.setFieldsValue(obj);
        });
    };

    const cancelEditing = () => {
        setEditing(null);
        form.resetFields();
    };

    const deletePosition = async (i) => {
        await aictia
            .delete(`${mainUrl}/${i}`)
            .then(() => {
                // description
                notify("silindi", true);
                getPositions();
            })
            .catch((err) => {
                //error
                notify(err.response, false);
            });
    };

    const savePosition = async (values) => {
        ;
        let obj = {
            typeOfActivity_Languages: lang.map((lang, index) => {
                return { languageId: lang.id, name: values[`name_${lang.id}`] };
            }),
        };
        if (!editing) {
            await aictia
                .post(mainUrl, obj)
                .then((res) => {
                    notify("", true);
                    getPositions();
                    cancelEditing();
                })
                .catch((err) => {
                    notify(err.response, false);
                });
        } else {
            await aictia
                .put(`${mainUrl}/${editing}`, { id: editing, ...obj })
                .then((res) => {
                    notify("", true);
                    getPositions();
                    cancelEditing();
                })
                .catch((err) => {
                    notify(err.response, false);
                });
        }
    };

    const getPositions = async () => {
        setSpin(true);
        await aictia.get(mainUrl).then((res) => {
            setSpin(false);
            setPositions(
                res.data.map((p, index) => {
                    return {
                        key: index + 1,
                        ...p,
                        index: index + 1,
                    };
                })
            );
        });
    };

    const getLanguage = async () => {

        await aictia.get('Language').then((res) => {

            setLang(res.data)
        });
    };

    useEffect(() => {
        getPositions();
        getLanguage();
    }, [t]);

    return (
        <Row gutter={[10, 10]} className="pl-1">
            <Col xs={24}>
                <div className="border flex animated fadeInDown p-2 mt-0 bg-white" style={{ borderRadius: '20px' }}>
                    <span
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: 12,
                            background: "#eff6ff",
                            color: "#0c82f4",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 10,
                            marginTop: 5,
                        }}
                    >
                        <UnorderedListOutlined className="f-20" />
                    </span>
                    <div>
                        <span className="f-20 bold">{t("typeOfActivity")}</span>
                        <p className="text-[11px] text-slate-450 font-medium">{t("typeOfActivitySub")}</p>
                    </div>
                </div>
            </Col>
            <Col lg={12} xs={24}>
                <Table
                    loading={spin}
                    size="small"
                    bordered={false}
                    rowKey="id"
                    className="animated fadeInLeft"
                    style={{
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 1px 2px rgba(15,23,42,.05)",
                    }}
                    columns={columns.map((col) => ({
                        ...col,
                        onHeaderCell: () => ({
                            style: {
                                background: "#f8fafc",
                                color: "#94a3b8",
                                fontSize: "10px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: ".05em",
                                borderBottom: "1px solid #e2e8f0",
                                padding: "8px 12px",
                            },
                        }),
                        onCell: () => ({
                            style: {
                                fontSize: "12px",
                                color: "#334155",
                                padding: "8px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                fontWeight: 500,
                            },
                        }),
                    }))}
                    components={{
                        header: {
                            cell: ({ children, ...restProps }) => (
                                <th
                                    {...restProps}
                                    style={{
                                        background: "#e5e7eb",
                                        color: "#828e9e",
                                        height: 56,
                                        padding: "12px",
                                        fontSize: 11,
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                        borderBottom: "1px solid #e2e8f0",
                                    }}
                                >
                                    {children}
                                </th>
                            ),
                        },
                    }}
                    dataSource={convertColumns(positions, cols)}
                    pagination={{
                        pageSize: 10,
                        current: 1,
                        total: positions.length,
                        size: "small",
                        showSizeChanger: false,
                        style: {
                            margin: "16px",
                        },
                    }}
                />
            </Col>
            <Col lg={12} xs={24}>
                <Card title={t("addTo")} className={"animated fadeInRight administrator"} style={{ borderRadius: '20px' }}>
                    <Form layout="vertical" onFinish={savePosition} form={form}>
                        {
                            lang.map((item, index) => {
                                return (
                                    <div className="form-lang mb-20" key={index}>
                                        <FloatLabel>

                                            <Form.Item
                                                className="mb-5"
                                                validateTrigger="onChange"
                                                name={`name_${item.id}`}
                                                rules={[whiteSpace(t("inputError"))]}
                                            >
                                                <InputText ref={nameInput} className="w-full" id={`name_${item.id}`} style={{ borderRadius: '12px' }} />
                                            </Form.Item>
                                            <label htmlFor={`name_${item.id}`}>{item.id == 1 ? 'Fəaliyyətin növünün adı' : item.id == 2 ? 'Faaliyet türü adı' : item.id == 3 ? 'Название вида деятельности' : item.id == 4 ? 'Type of activity name' : ''}</label>

                                            <div className="input-lang">{item.uniCode}</div>
                                        </FloatLabel>

                                    </div>
                                )
                            })
                        }
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: 15,
                                width: "100%",
                            }}
                        >
                            <Button
                                onClick={cancelEditing}
                                style={{
                                    height: 36,
                                    padding: "0 16px",
                                    borderRadius: 10,
                                    background: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: "#334155",
                                }}
                            >
                                {t("cancel")}
                            </Button>

                            <Button
                                htmlType="submit"
                                style={{
                                    height: 36,
                                    padding: "0 16px",
                                    borderRadius: 10,
                                    background: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: "#334155",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                {t("save")}
                            </Button>
                        </div>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};

const mapStateToProps = ({ langs }) => {
    return {
        langs: langs,
    };
};

export default connect(mapStateToProps, { notify })(TypeOfActiviyAictia);
